import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules'
import Container from '../utils/Container';
import { useState } from 'react';

import SectionTitle from "../utils/SectionTitle"

// Partners Images
import partner01 from '../../assets/droit_penal_general.svg'
import partner02 from '../../assets/droit_penal_des_affaires.svg'
import partner03 from '../../assets/droit_penal_du_travail.svg'
import partner04 from '../../assets/droit_penal_international.svg'
import partner05 from '../../assets/droit_penal_routier.svg'
import partner06 from '../../assets/application_des_peines.svg'
import partner07 from '../../assets/droit_penal_des_mineurs.svg'


const Clients = () => {
  const [width, setWidth] = useState(+window.innerWidth)

  window.addEventListener("resize", () => {
    setWidth(+window.innerWidth)
  })

  return (
    <section id="skills">
      <Container>
      <SectionTitle title="Compétences"></SectionTitle>
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={50}
          slidesPerView={
            width >= 0 && width < 640
            ? 2
            : width >= 640 && width < 768
            ? 3
            : width >= 768
            ? 4
            : 4
          }
          autoplay
          pagination={{ clickable: true }}
          className="cursor-grab"
        >
          <SwiperSlide className='!my-auto !pb-12'>
            <img src={partner01} alt="Partner" className='mx-auto' />
          </SwiperSlide>
          <SwiperSlide className='!my-auto !pb-12'>
            <img src={partner07} alt="Partner" className='mx-auto' />
          </SwiperSlide>
          <SwiperSlide className='!my-auto !pb-12'>
            <img src={partner02} alt="Partner" className='mx-auto' />
          </SwiperSlide >
          <SwiperSlide className='!my-auto !pb-12'>
            <img src={partner04} alt="Partner" className='mx-auto' />
          </SwiperSlide>
          <SwiperSlide className='!my-auto !pb-12'>
            <img src={partner06} alt="Partner" className='mx-auto' />
          </SwiperSlide>
          <SwiperSlide className='!my-auto !pb-12'>
            <img src={partner05} alt="Partner" className='mx-auto' />
          </SwiperSlide>
          <SwiperSlide className='!my-auto !pb-12'>
            <img src={partner03} alt="Partner" className='mx-auto' />
          </SwiperSlide>
        </Swiper>
      </Container>
    </section>
  )
}

export default Clients
